export default "__VITE_ASSET__DX_owGQs__"